import {itSetting} from "./config/it";

export const itMoment = (moment: any) => {
    return moment.locale('it', itSetting);
}
